import styled from "styled-components";

export const DetailSection = styled.section`
  margin-bottom: 4rem;
  scroll-margin-top: 5.75rem;

  @media (min-width: 992px) {
    margin-bottom: 4.25rem;
  }

  .section-eyebrow {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-secondary);
    margin-bottom: 0.35rem;
  }

  .section-title {
    font-size: clamp(1.15rem, 2.5vw, 1.4rem);
    font-weight: 600;
    color: #383838;
    margin-bottom: 0.35rem;
  }

  .section-subtitle {
    font-size: 0.95rem;
    color: #525252;
    margin-bottom: 1.25rem;
    max-width: 42rem;
    line-height: 1.6;
  }
`;

export default function InvestmentDetailSection({
  id,
  eyebrow,
  title,
  subtitle,
  children,
  className = "",
}) {
  return (
    <DetailSection id={id} className={className} aria-labelledby={id ? `${id}-title` : undefined}>
      {eyebrow ? <p className="section-eyebrow mb-0">{eyebrow}</p> : null}
      {title ? (
        <h2 className="section-title" id={id ? `${id}-title` : undefined}>
          {title}
        </h2>
      ) : null}
      {subtitle ? <p className="section-subtitle">{subtitle}</p> : null}
      {children}
    </DetailSection>
  );
}
